@if (loading) {
  <mbs-loader></mbs-loader>
} @else if (companiesData) {
  <mbs-card class="card-form">
    <mbs-card-group>
      <div class="mbs-form-group">
        {{ 'storages:addStorageAccountWizard.companiesStep.intro' | i18next }}
      </div>

      @if (companiesLocked && !companiesData.canRestrictByCompanies) {
        <mbs-alert
          class="mb-0"
          [icon]="true"
          [type]="mbsPopupType.warning">
          {{ 'storages:addStorageAccountWizard.companiesStep.cannotLockCompany' | i18next }}
        </mbs-alert>
      }

      <div class="mbs-form-group">
        <div class="mb-2">
          <mbs-radio
            [formControl]="restrictControl"
            [label]="'storages:addStorageAccountWizard.companiesStep.anyCompany' | i18next"
            [value]="false"></mbs-radio>
        </div>
        <div 
          [container]="'body'"
          [ngbTooltip]="restrictControl?.enabled ? '' : ('storages:addStorageAccountWizard.companiesStep.cannotRestrict' | i18next)">
          <mbs-radio
            [formControl]="restrictControl"
            [label]="'storages:addStorageAccountWizard.companiesStep.specificCompanies' | i18next"
            [value]="true"></mbs-radio>
        </div>
      </div>

      @if (restrictControl.value) {
        <div class="mbs-form-group pl-4">
          <mbs-companies-picker
            [companiesControl]="companiesControl"
            [disabled]="companiesLocked"
            [disabledHint]="'storages:addStorageAccountWizard.companiesStep.lockedHint' | i18next"
            [disabledIds]="companiesData.destinationCompanyIds ?? []"
            [selectedIds]="selectedCompanyIds"></mbs-companies-picker>
        </div>
      }
    </mbs-card-group>
  </mbs-card>
}
